export const localeStandard = 'ISO639';
